module.exports = __webpack_public_path__ + "assets/d836017d20d6b74e453725e283b58bf2.mp3";